import React, { useEffect, useRef, useState } from "react";

/**
 * Wraps children to trigger CSS `in-view` class when scrolled into viewport.
 * Works with `.reveal` and `.reveal-stagger` classes defined in index.css.
 */
export default function Reveal({
  as: As = "div",
  className = "",
  stagger = false,
  once = true,
  children,
  ...rest
}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          if (once) io.unobserve(el);
        } else if (!once) {
          setVisible(false);
        }
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [once]);

  const base = stagger ? "reveal-stagger" : "reveal";
  return (
    <As
      ref={ref}
      className={`${base} ${visible ? "in-view" : ""} ${className}`}
      {...rest}
    >
      {children}
    </As>
  );
}
